<template>
  <div class="login-page">
    <div class="background-image"></div>
    <div class="container d-flex justify-content-center">
      <div class="card shadow-lg mt-5 border-0 max-width">
        <div class="card-body p-1">
          <h4
              class="card-title mb-3 text-dark text-uppercase"
              style="font-weight: 700"
          >
            <span style="color: #9ccc65">Otp</span> Login
          </h4>
          <form @submit.prevent="login">
            <input class="form-card-input" placeholder="______" maxlength="6" type="tel" v-model="form.otp">
            <button class="btn btn-success" type="submit" :disabled="loading" style="margin-bottom: 3px">
              <div
                  class="spinner-border"
                  style="width: 2rem; height: 2rem"
                  role="status"
                  v-if="this.loadingText === 'Loading...'"
              ></div>
              <span role="status" class="ps-4">{{ this.loadingText }}</span>
            </button>
            <button class="btn btn-success" type="button" :disabled="loading" @click="resendOtp">
              <span class="ps-4">Resend OTP</span>
            </button>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import Header from "@/components/layout/utils/Header";
import Swal from "sweetalert2";
export default {
  name: "otpForm",
  components: {Header},
  data() {
    return {
      otpData: {},
      form: {
        otp: "",
       },
      otpDigits: ["", "", "", ""], // For the individual input boxes
      loading: false,
      showPass: false,
    };
  },
  computed: {
    passType() {
      return this.showPass ? "text" : "password";
    },
    loadingText() {
      return this.loading ? "Loading..." : "Login";
    },
  },
  methods: {
    login() {
      const otp = String(this.form.otp || "").trim();
      if (!/^\d{6}$/.test(otp)) {
        Swal.fire({
          icon: "warning",
          title: "Invalid OTP",
          text: "Please enter the 6-digit OTP sent to your phone.",
        });
        return;
      }

      this.loading = true;
      return this.$store.dispatch("validateUser2", { otp })
          .then((result)=> {
            localStorage.setItem('isLoggedIn', 'true');
            if (result.role === `Super_User`) return this.$router.push({ name : `Dashboard` })
            return this.$router.push({ name : `Funds` })
          }).finally(() => this.loading = false)
    },
    resendOtp() {
      this.otpData = JSON.parse(localStorage.getItem("form"));
      return this.$store.dispatch("validateUser", this.otpData)
    },
  },
};
</script>

<style lang="scss" scoped>
.login-page {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.background-image {
  background-color: #f5f5f5;
  background-size: cover;
  background-position: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.parent {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.card {
  max-width: 400px;
  width: 95vw;
  position: relative;
  background: rgba(255, 255, 255, 0.5); /* Slightly opaque background */
  backdrop-filter: blur(8px); /* Subtle blur for the frosted effect */
}

button {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  span{
    font-size: 1.3rem;

  }
}

.form {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
  width: 300px;
  background-color: white;
  border-radius: 12px;
  padding: 20px;
}

.title {
  font-size: 20px;
  font-weight: bold;
  color: black
}


.form-card-input {
  width: 100%;
  padding-left: 15%;
  margin-bottom: 10px;
  border-radius: 10px;
  color: #198754;
  border: none;
  font-size: 2rem;
  font-weight: bold;
  letter-spacing: 2rem;
  text-align: start;
  z-index: 3;
  background-color: transparent;
}
</style>
